const operationData = {
  "export-request": {
    title: "Požadavek na export souborů",
    message: ({ entry }) =>
      `Soubory: ${entry.payload.files?.map((f) => JSON.stringify(f))?.join(", ")}`,
  },
  "export-medical-report-request": {
    title: "Požadavek na export",
    message: () => "Zaslán požadavek na export zdravotní dokumentace.",
  },
};

function getOperationData(entry) {
  const operation = entry.payload.operation;

  return operationData[operation] ?? { title: "Webhook", message: "" };
}

export function getWebhookTitle({ entry }) {
  return getOperationData(entry).title;
}

export default function Webhook(props) {
  const { entry } = props;

  return getOperationData(entry).message(props);
}
